import { FIELD_TYPES } from "../../constants/formFields";

// Left column: field types (Bootstrap)
export default function Palette({ onAdd }) {
  return (
    <div className="card shadow-sm">
      <div className="card-header py-2 small fw-semibold text-secondary text-uppercase">
        Field types
      </div>
      <div className="card-body p-2">
        {FIELD_TYPES.map((t) => {
          const Icon = t.icon;
          return (
            <button
              key={t.type}
              type="button"
              draggable
              onDragStart={(e) => e.dataTransfer.setData("newtype", t.type)}
              onClick={() => onAdd(t.type)}
              className="fb-palette-item btn btn-light text-start border w-100 d-flex align-items-center gap-2 mb-2 p-2"
            >
              <span className="fb-icon bg-dark text-white">
                <Icon size={13} />
              </span>
              <span className="fw-medium small text-body">{t.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
